import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLocalStorage } from 'react-use';
import envConfig from '../envConfig';

function ProtectedRoute({ children }) {
  const [user] = useLocalStorage(`${envConfig.StoragePrefix}-user`);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
